import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FacettenResetService } from '../../../services/facetten/facetten-reset.service';

@Component({
  selector: 'now-wbsuche-lib-filter-zuruecksetzen',
  templateUrl: './filter-zuruecksetzen.component.html',
  imports: [CommonModule]
})
export class FilterZuruecksetzenComponent {
  facettenResetService = inject(FacettenResetService);

  showZuruecksetzen$ = this.facettenResetService.showZuruecksetzen$;
}
